<template>
  <el-dialog title="帮助文档" :visible.sync="localDialogTableVisible" :before-close="close"  :close-on-click-modal="false"
      :append-to-body="true">
    <h3>什么是场景联动</h3>
    <h4>更新时间：2020年5月15日 17:00:29</h4>
    <p>场景联动是规则引擎中，
      一种开发自动化业务逻辑的可视化编程方式，
      您可以通过可视化的方式定义设备之间联动规则，
      并将规则部署至云端或者边缘端</p>
    <p>您需在物联网平台控制台
      ，规则引擎 > 场景联动页面中创建场景联动规则。
      每个场景联动规则由触发器（Trigger）、
      执行条件（Condition）、执行动作（Action）
      三个部分组成。这种规则模型称为TCA模型
      。</p>
    <p>当触发器指定的事件或属性变化事件发生时，
      系统通过判断执行条件是否已满足
      ，来决定是否执行规则中定义的执行动作。
      如果满足执行条件，则直接执行定义的执行动作；
      反之则不执行。
    </p>
    <p>例如，您每天18:00下班回家。
      在炎热的夏天，您希望您到家后，
      家里的温度是凉爽、舒适的。
      您可以创建一条规则，
      使空调设备自动化，实现这个需求。
    </p>
    <h4>参数设置如下图。</h4>
    <img width="90%" src="@/assets/imgs/ruleEngine/p6486.png" alt="">
    <h4>参数说明如下：</h4>
    <img width="90%" src="@/assets/imgs/ruleEngine/p6486.png" alt="">
  </el-dialog>
</template>

<script>
export default {
  name: 'Instruction',
  data () {
    return {
      localDialogTableVisible: false
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    dialogVisible: {
      handler (value) {
        this.localDialogTableVisible = value
      },
      immediate: true
    }
  },
  methods: {
    close () {
      this.$emit('update:dialogVisible', false)
    }
  }
}
</script>

<style scoped>

</style>
